const adminGuard = ({ next }, { authClient }) => {
	if (!authClient.is("admin")) {
		next({ name: "AuthIndex" })
	} else {
		next()
	}
}

const guestGuard = ({ next }, { authClient }) => {
	if (!authClient || authClient.is("guest")) {
		next({ name: "AuthIndex" })
	} else {
		next()
	}
}

/**
 * Маршруты приложения
 * @param {Object} context
 * @return {Array}
 */
export default ({ authClient }) => {
	return [
		// Основные маршруты
		{
			path: "/",
			component: () => import("../layouts/Clean"),
			children: [
				{
					name: "AuthIndex",
					path: "",
					redirect: () => {
						if (authClient.is("admin")) {
							// console.log(3)
							return { name: "AdminIndex" }
						} else if (authClient.is("logged")) {
							// console.log(4)
							return { name: "PanelIndex" }
						} else {
							// console.log(5)
							return { name: "AuthLogin" }
						}
					}
				},
				{
					name: "AuthCheck",
					path: "check",
					props: true,
					component: () => import("../views/auth/Check"),
					meta: {
						guard: ({ next }) => next()
					}
				},
				// {
				// 	name: "AuthCooka",
				// 	path: "cooka",
				// 	props: true,
				// 	component: () => import("../views/auth/Cooka"),
				// 	meta: {
				// 		guard: ({ next }) => next()
				// 	}
				// },
				{
					name: "AuthLogin",
					path: "login",
					component: () => import("../views/auth/Login"),
					meta: {
						guard: ({ next }, { authClient }) => {
							if (authClient.is("logged")) {
								// console.log(6)
								next({ name: "AuthIndex" })
							} else {
								// console.log(7)
								next()
							}
						}
					}
				}
			]
		},

		// Панель пользователя
		{
			path: "/panel",
			component: () => import("../layouts/Clean"),
			children: [
				{
					name: "PanelIndex",
					path: "",
					component: () => import("../views/panel/Index"),
					meta: {
						guard: guestGuard
					}
				}
			]
		},

		// Управление
		{
			path: "/admin",
			component: () => import("../layouts/Admin"),
			children: [
				{
					name: "AdminIndex",
					path: "",
					component: () => import("../views/admin/Index"),
					meta: {
						guard: adminGuard
					}
				},

				// Обработка импортированных пользователей
				{
					path: "import",
					name: "AdminImport",
					component: () => import("../views/admin/Import"),
					meta: {
						guard: adminGuard
					}
				}
			]
		},

		// Непонятное, но у админа - тогда на его главную страницу
		// {
		// 	path: "/admin/*",
		// 	redirect: "/admin"
		// },

		// 404
		{
			name: "NotFound",
			path: "*",
			component: () => import("../views/NotFound")
		}
	]
}
